import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import PoServices from "../../../services/PoServices"; // Ensure this imports the updateUser method
import UserServices from "../../../services/UserServices"; // Ensure this imports the updateUser method
import Swal from "sweetalert2";
import UseEditModal from './SupplierEditModal';
import Select from 'react-select';
import Pagination from "../Pagenation/Pagenation";


const InactiveSuppliersList = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [sort, setSort] = useState(20); // Number of items per page
  const [activePage, setActivePage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeUsers, setActiveUsers] = useState([]);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState();

  useEffect(() => {
    const fetchUsers = async () => {
      const response = await PoServices.inactiveSuppliers();
      const filteredActiveUsers = response?.data || [];
      setActiveUsers(filteredActiveUsers);
    };

    fetchUsers();
  }, [test]);

  // User search
  const filteredSearch = activeUsers.filter(user =>
    user?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Options for row selections
  const options = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ];

  // Pagination setup
  useEffect(() => {
    setActivePage(0);
  }, [activeUsers, sort, searchTerm]);

  // Calculate total pages
  const totalPages = Math.ceil(filteredSearch.length / sort);

  // Handle page click
  const handlePageChange = (page) => {
    setActivePage(page);
  };

  // Handle deleting user
  function handleDelete(e, user) {
    Swal.fire({
      title: 'Are you sure to delete?',
      text: "You will not be able to recover this User Again!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dd6b55',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        PoServices.deleteSupplier(user._id).then(() => {
          setTest(user._id);
          Swal.fire('Deleted!', 'Supplier has been deleted.', 'success');
        }).catch((error) => {
          Swal.fire('Error!', 'There was a problem deleting the Supplier.', 'error');
        });
      }
    });
  }

  // Handle status toggle using the updateUser service
  const handleStatusToggle = async (user) => {
    const newStatus = user.status === "active" ? "inactive" : "active";
    const updatedUser = { ...user, status: newStatus }; // Create updated user object

    try {
      await PoServices.updateSupplier(user._id, updatedUser); // Use the updateUser service
      setTest(prev => prev + 1); // Trigger re-fetch or re-render
      Swal.fire('Success!', `Supplier status updated to ${newStatus}.`, 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error!', 'There was a problem updating the Supplier status.', 'error');
    }
  };

  const handleEditClick = (item) => {
    setSelectedItem(item); // Set the item to be edited
    setGridInsideModal(true); // Show modal
  };


  return (
    <>
      <UseEditModal
        admin={selectedItem}
        show={gridInsideModal}
        test={setTest}
        handleClose={() => setGridInsideModal(false)}
      />


      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-xxl-6">
                      <input type="text"
                        className="form-control mb-xl-0 mb-3"
                        id="exampleFormControlInput1"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="col-xl-3 col-xxl-6">
                      <Select
                        placeholder="Select row to display in User Table"
                        value={options.find(option => option.value === sort)} // set the current selected value
                        onChange={(selectedOption) => setSort(selectedOption.value)} // update `sort` on selection
                        isSearchable={false}
                        options={options}
                        className="custom-react-select mb-3 mb-xxl-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-list me-2" aria-hidden="true"></i>In-Active Suppliers <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
              </div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div id="content_wrapper" className="dataTables_wrapper no-footer">
                      <div className="scrolltable">
                        <table
                          className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                          id="active-users-data"
                        >
                          <thead
                            className="sticky-table-header"
                          >
                            <tr>
                              <th>S.No</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Mobile No.</th>
                              <th>Street</th>
                              <th>City</th>
                              <th>State</th>
                              <th>Pincode</th>
                              <th>Country</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredSearch.length > 0 ? (
                              filteredSearch
                                .slice(
                                  activePage * sort,
                                  (activePage + 1) * sort
                                ).map((user, index) => (
                                  <tr key={index}>
                                    <td>{activePage * sort + index + 1}</td>
                                    <td>{user?.name}</td>
                                    <td>{user?.email}</td>
                                    <td>{user?.mobileNo}</td>
                                    <td className="scrollable-description">
                                      {user?.address?.street}
                                    </td>
                                    <td>{user?.address?.city}</td>
                                    <td>{user?.address?.state}</td>
                                    <td>{user?.address?.pincode}</td>
                                    <td>{user?.address?.country}</td>


                                    <td>
                                      <span
                                        onClick={() => handleStatusToggle(user)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <i
                                          className={`fa ${user.status === 'active' ? 'fa-circle text-success' : 'fa-circle text-danger'}`}
                                          title={user.status === 'active' ? 'Active' : 'Inactive'}
                                        ></i>
                                      </span>
                                    </td>

                                    <td className="text-center">
                                      <button
                                        className="btn btn-primary btn-xs sharp"
                                        onClick={() => handleEditClick(user)} // Open modal on edit click
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </button>
                                      <button className="btn btn-danger btn-xs sharp" onClick={(e) => { handleDelete(e, user) }}>
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="11" className="text-center">No Active Users Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">

                        <div className="dataTables_info">
                          {filteredSearch.length > 0
                            ? `Showing ${activePage * sort + 1
                            } to ${Math.min(
                              filteredSearch.length,
                              (activePage + 1) * sort
                            )} of ${filteredSearch.length} entries`
                            : "Showing 0 to 0 of 0 entries"}
                        </div>

                        {totalPages > 0 && (
                          <Pagination
                            activePage={activePage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                          />
                        )}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default InactiveSuppliersList;
